//Actions
export const CLICK = 'click';
export const REGISTRO = 'registro';
export const REGISTRO_TELMEX = 'registro telmex';
export const IP_TV = 'ip tv';
export const TICKER = 'ticker';
export const SELECCION_DE_PLAN = 'seleccion de plan';
export const METODO_DE_PAGO = 'metodo de pago';
export const ADD_ON_REGISTRO = 'add on - registro';
export const ADD_ON_VCARD = 'add on - vcard';
export const ADD_ON_TV = 'add on - tv';
export const SUSCRIPCION_CLARO_VIDEO_REGISTRO = 'suscripcion claro video - registro';

//Components
export const COMPONENTE_LANDING = 'landing';
export const COMPONENTE_REGISTRO = 'registro';
export const COMPONENTE_MODAL_TERMINOS_Y_CONDICIONES = 'registro';
export const COMPONENTE_IP_TV = 'ip tv';
export const COMPONENTE_TICKER = 'home';
export const COMPONENTE_SELECIONA_TU_PLAN = 'selecciona tu plan - home';
export const COMPONENTE_MEDIOS_DE_PAGO = 'medios de pago';
export const COMPONENTE_SELECCIONAR_MEDIO_DE_PAGO = 'seleccionar metodo de pago ';
export const COMPONENT_REGISTRO_EXITOSO = 'registro exitoso';
export const COMPONENT_SUSCRIPCION = 'suscripcion';

//Labels landing component
export const LABEL_REGISTRATE = 'registrate';
export const LABEL_INICIA_SESION = 'inicia sesion';
export const LABEL_VER_GRATIS = 'ver gratis';
export const ACTIVAR_CODIGO_PROMOCIONAL = 'activar codigo promocional';

//Labels register component
export const SELECCION_PAIS = 'seleccion pais -';
export const TERMINOS_Y_CONDICIONES = 'terminos y condiciones';
export const TERMINOS_Y_CONDICIONES_VOLVER = 'terminos y condiciones - volver';
export const ACEPTAR_TERMINOS_Y_CONDICIONES = 'aceptar terminos y condiciones';
export const CONOCE_LAS_PROMOCIONES = 'conoce las promociones';
export const CONOCE_LAS_PROMOCIONES_ENTENDIDO = 'conoce las promociones - entendido';
export const INICIA_SESION = 'inicia sesion';
export const CORREO_SIGUIENTE = 'correo - siguiente';
export const CORREO_CANCELAR = 'correo - cancelar';
export const CORREO_INGRESAR_CONTRASEÑA_SIGUIENTE = 'correo - Ingresar contraseña - siguiente';
export const CORREO_INGRESAR_CONTRASEÑA_CANCELAR = 'correo - Ingresar contraseña - cancelar';
export const EXITOSO_CORREO = 'exitoso - correo';
export const OPERADORA_REENVIAR_CODIGO = 'operadora - reenviar codigo';
export const OPERADORA_CODIGO_SIGUIENTE = 'operadora - codigo - siguiente';
export const OPERADORA_CODIGO_CANCELAR = 'operadora - codigo - cancelar';
export const EXITOSO_OPERADORA = 'exitoso - operadora';
export const CODIGO_PROMOCIONAL_SIGUIENTE = 'codigo promocional - siguiente';
export const CODIGO_PROMOCIONAL_CANCELAR = 'codigo promocional - cancelar';

export const TERMINOS_Y_CONDICIONES_IP = 'terminos y condiciones';
export const TERMINOS_Y_CONDICIONES_VOLVER_IP = 'terminos y condiciones - volver';
export const ACEPTAR_TERMINOS_Y_CONDICIONES_IP = 'aceptar terminos y condiciones';
export const INICIAR_SESION_CON_OTRA_CUENTA = 'iniciar sesion con otra cuenta';
export const COMPLETAR_DATOS_SIGUIENTE = 'completar datos - siguiente';
export const COMPLETAR_DATOS_CANCELAR = 'completar datos - cancelar';
export const COMPLETAR_DATOS_INGRESAR_CONTRASEÑA_SIGUIENTE = 'completar datos  - ingresar contraseña - siguiente';
export const COMPLETAR_DATOS_INGRESAR_CONTRASEÑA_CANCELAR = 'completar datos  - ingresar contraseña - cancelar';
export const EXITOSO_IP_TELMEX = 'exitoso - ip telmex';
export const OBTENER_CODIGO = 'obtener codigo';
export const REGISTRATE = 'registrate';
export const REGRESAR = 'regresar';
export const CODIGO_DE_ACCESO_SIGUIENTE = 'codigo de acceso - siguiente';
export const CODIGO_DE_ACCESO_CANCELAR = 'codigo de acceso - cancelar';
export const DISPOSITIVO_REGISTRADO_ACEPTAR = 'dispositivo registrado - aceptar';
export const SIGUIENTE = 'siguiente';
export const OMITIR = 'omitir';
export const INICA_SESION = 'inica sesion';
export const ACTIVACION_EXITOSA_ACEPTAR = 'activacion exitosa - aceptar';
export const ABRIR_TELMEX = 'abrir';
export const CERRAR_TELMEX = 'cerrar';
export const ABRIR_SUSCRIPCION = 'abrir';
export const CERRAR_SUSCRIPCION = 'cerrar';
export const CONTRATA_PLAN_SELECCIONADO = 'contrata ';
export const PLAN_SELECCIONADO_QUE_INCLUYE = ' que incluye';
export const AGREGAR_MEDIO_DE_PAGO = 'agregar medio de pago';
export const CANCELAR_MEDIO_PAGO = 'cancelar';
export const METODO_DE_PAGO_SELECCIONADO = 'metodo de pago seleccionado';
export const METODO_DE_PAGO_CANCELAR = 'cncelar';
export const EXITOSO_ADD_ON_CONTRATADO_METODO_DE_PAGO = 'exitoso - ';
export const EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO = 'exitoso - ';
export const CLAROVIDEO = 'clarovideo';
export const COMPRAS_VCARD = 'compras vcard';


//Metrics Actions
export const QUE_INCLUYE = 'que incluye';

//Components
export const COMPONENT_VCARD = 'vcard';

//Labels plan selector 
export const LABEL_PRUEBA_30_DIAS = ' -  prueba 30 dias sin costo';
export const LABEL_SUSCRIBETE_AHORA = ' -  suscribete ahora';
export const VCARD_COMPONENT = 'vcard';
export const VCARD_CLICK = ' -  suscribete ahora';


// WEBPACK FOOTER //
// ./src/authentication/utils/constansMetrics.ts